<template>
    <div >
        <div>
<!--            <div class="block"><el-avatar :size="50" :src="123"></el-avatar></div>-->
            <el-avatar class="el-dropdown-link" :style="{'margin-top':'8px'}"> {{this.$store.state.a.info.username}}</el-avatar>
<!--            <el-dropdown>-->
<!--                <el-avatar class="el-dropdown-link"> user </el-avatar>-->
<!--                <el-dropdown-menu slot="dropdown">-->
<!--                    <el-dropdown-item icon="el-icon-plus">黄金糕</el-dropdown-item>-->
<!--                    <el-dropdown-item icon="el-icon-circle-plus">狮子头</el-dropdown-item>-->
<!--                    <el-dropdown-item icon="el-icon-circle-plus-outline">螺蛳粉</el-dropdown-item>-->
<!--                    <el-dropdown-item icon="el-icon-check">双皮奶</el-dropdown-item>-->
<!--                    <el-dropdown-item icon="el-icon-circle-check">蚵仔煎</el-dropdown-item>-->
<!--                </el-dropdown-menu>-->
<!--            </el-dropdown>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "UserLogin"
    }
</script>

<style scoped>

</style>